import * as React from 'react';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import { PaginationComponent } from '../../../components/tables/footerTableAction/footerTableAction-style';
import { TextField, MenuItem } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useContext, useEffect, useState } from 'react';
import { useApi } from '../../../hooks/userApi';
import { formatDinheiro } from '../../../utils/formatDinheiro';
import { LoadingContext } from '../../../context/Loading/LoadingContext';
import BtnPesquisa from '../../../components/BtnPesquisa/BtnPesquisa';
import { CarrinhoContext } from '../../../context/Carrinho/CarrinhoContext';
import * as S from 'styles/orcamento/orcamento.style';
import { BoxFilter } from 'styles/Global.styles';
import { TFilterProps } from '@typings/filter';
import ButtonPrimary from 'components/Buttons/ButtonPrimary/ButtomPrimary.component';
import TableComponente from 'components/tables/TableComponente/TableComponente.component';

const api = useApi();

const SelectVendedor = (props: TFilterProps) => {
  const [vendedores, setVendedores] = useState([props.user]);
  const { setLoading, setLoadingMensagem, setLoadingBtn }: any = useContext(LoadingContext);

  if (props.user.permissions.includes('Admin')) {
    useEffect(() => {
      setLoading(true);
      api
        .get('vendedor')
        .then((r) => {
          if (!r.status) {
            setLoadingMensagem('Desculpe ocorreu um erro!');
            setLoadingBtn('OK');
            return;
          }
          setLoading(false);
          setVendedores(r.results);
        })
        .catch((err) => {
          alert('ops! ocorreu um erro' + err);
        });
    }, []);
  }

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'flex-start',
          alignItems: 'end !important',
          flexWrap: 'wrap',
          p: 1,
          m: 1,
        }}
      >
        <TextField
          select
          label="Vendedor"
          defaultValue={props.vendedor}
          onChange={props.handleChangeInput}
          style={{ position: 'relative', zIndex: 0 }}
          variant="outlined"
        >
          {vendedores &&
            vendedores.map((option, index) => (
              <MenuItem key={index} value={option.id}>
                {option.nome}
              </MenuItem>
            ))}
        </TextField>
      </Box>
    </>
  );
};

export default function Orcamentos() {
  const navigate = useNavigate();

  const { setLoading, setLoadingMensagem, setLoadingBtn }: any = useContext(LoadingContext);

  const { addProdutoCar, clearProdutoCar, addClienteCar }: any = useContext(CarrinhoContext);

  const user = JSON.parse(sessionStorage.getItem('user'));
  const [vendedor, setVendedor] = useState(user.id);
  const [orcamentos, setOrcamentos] = useState([]);
  const [page, setPage] = useState(1);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [limit, setLimit] = useState<number>(Number(process.env.REACT_APP_PAGINATION_DEFAULT) || 15);
  const [pageTotal, setPageTotal] = useState<number>(0);
  const [like, setLike] = useState<string>('all');

  const handleChangePage = (event: React.ChangeEvent<unknown>, value: number) => {
    setPage(value);
  };

  const handclick = async () => {
    navigate('/vendedor/listaClientes');
  };

  const handleChangeInput = (event: React.ChangeEvent<HTMLInputElement>) => {
    setPage(1);
    setVendedor(event.target.value);
  };

  const handchanceOrcamento = (id) => {
    navigate('/vendedor/checkoutPDF/' + id);
  };

  const handDuplicaOrcamento = (row) => {
    clearProdutoCar();
    setLoading(true);
    api
      .get('orcamento-produto/orcamento/' + row.id)
      .then((r) => {
        addClienteCar(row.cliente);
        Promise.all(
          r.map((item) => {
            return addProdutoCar(item);
          }),
        ).then(() => {
          navigate('/vendedor/checkout');
        });
      })
      .catch((e) => {
        const msg = 'Houve um erro interno, tente mais tarde.  (' + e.response.status + ')';

        setLoadingMensagem(msg);
        setLoadingBtn('OK');
      });
  };

  const handleLike = (value) => {
    setPage(1);
    setLike(value);
  };

  useEffect(() => {
    setLoading(true);
    api
      .get('orcamento/vendedor/' + vendedor + `?offset=${limit * (page - 1)}&limit=${limit}&like=${like}`)
      .then((r) => {
        if (!r.status) {
          setLoadingMensagem('Desculpe ocorreu um erro!');
          setLoadingBtn('OK');
          return;
        }
        setLoading(false);
        setOrcamentos(r.results);
        setPageTotal(r.page_total);
      })
      .catch((e) => {
        const msg = 'Houve um erro interno, tente mais tarde.  (' + e.response.status + ')';

        setLoadingMensagem(msg);
        setLoadingBtn('OK');
      });
  }, [vendedor, page, like]);

  function formataTable(objeto) {
    const novoObjeto = objeto.map((row) => {
      return {
        rowCell: [
          { campo: row.cliente?.nome || '-', onClick: null, link: false },
          { campo: row.cliente?.estado || '-', onClick: null, link: false },
          { campo: new Date(row?.created_at || '').toLocaleDateString('pt-br'), onClick: null, link: false },
          { campo: new Date(row?.validade || '').toLocaleDateString('pt-br'), onClick: null, link: false },
          { campo: row?.cod || '-', onClick: null, link: false },
          { campo: formatDinheiro(row?.descontoFrete || '0'), onClick: null, link: false },
          { campo: formatDinheiro(row?.precoFinal || '0'), onClick: null, link: false },
          { campo: formatDinheiro(row?.precoFinal - row?.descontoFrete || '0'), onClick: null, link: false },
          { campo: row?.status || '-', onClick: null, link: false },
          { campo: 'Duplicar', onClick: () => handDuplicaOrcamento(row), link: true },
          { campo: 'Baixar', onClick: () => handchanceOrcamento(row.id), link: true },
        ],
      };
    });
    return novoObjeto;
  }
  const table = [
    'Nome do Cliente',
    'Localização',
    'Criação',
    'Validade',
    'Proposta',
    'Desconto',
    'Orçamento',
    'Valor Final',
    'Status',
    'Duplicar',
    'Baixar',
  ];

  return (
    <Stack spacing={2} width="100%">
      <S.BoxContainer>
        <S.ContainerBoxSelecao>
          <SelectVendedor user={user} vendedor={vendedor} handleChangeInput={handleChangeInput} />
        </S.ContainerBoxSelecao>
        <S.FilterBox>
          <ButtonPrimary label={'Kanban'} typeSubmit={false} onClick={() => navigate('/vendedor/kanban')} />
          <BtnPesquisa handleLike={handleLike} />
        </S.FilterBox>
      </S.BoxContainer>
      <TableComponente table={table} data={formataTable(orcamentos)} />
      <BoxFilter>
        {pageTotal > 1 && (
          <>
            <div>
              Apresentando {page} de {pageTotal} resultados
            </div>
            <PaginationComponent count={pageTotal} page={page} onChange={handleChangePage} />
          </>
        )}
        <ButtonPrimary label={'+ NOVO ORÇAMENTO'} typeSubmit={false} onClick={() => handclick()} />
      </BoxFilter>
    </Stack>
  );
}
